import * as PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Alert from 'antd/lib/alert';
import { TextField } from '@ackee/mateus';
import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';
import Tabs from 'antd/lib/tabs';

import { Icon as LayoutIcon } from 'modules/layout';
import { SelectField } from 'modules/ui';
import config from 'config/index';

import rule, { item } from './PinForm.rule';

import { pinFields } from '../../services/config';
import { PIN_CATEGORIES } from '../../constants';

const TabPane = Tabs.TabPane;

const PinsForm = ({ handleSubmit, submitting, error, cancel }) => {
    const intl = useIntl();
    const { css } = useFela();

    const categories = PIN_CATEGORIES.map(category => ({
        value: category,
        label: (
            <span className={css(item)}>
                <LayoutIcon width="16" height="16" style={{ marginRight: '8px' }} type={category} />
                <FormattedMessage id={`pins.categories.${category}`} />
            </span>
        ),
    }));
    return (
        <form onSubmit={handleSubmit} className={css(rule)}>
            <h3>
                <FormattedMessage id="form.section.translations" />
            </h3>
            {error && <Alert type="error" message={intl.formatMessage({ id: error })} />}
            <Tabs>
                {config.app.languages.map(lang => (
                    <TabPane tab={<FormattedMessage id={`languages.${lang}`} />} key={lang}>
                        <TextField
                            name={`${lang}.${pinFields.title}`}
                            label={intl.formatMessage({ id: `pins.add.form.title.label` })}
                            labelAlign="left"
                            labelCol={{ span: 24 }}
                        />
                        <TextField
                            name={`${lang}.${pinFields.subtitle}`}
                            label={intl.formatMessage({ id: `pins.add.form.subtitle.label` })}
                            labelAlign="left"
                            labelCol={{ span: 24 }}
                        />
                    </TabPane>
                ))}
            </Tabs>
            <h3>
                <FormattedMessage id="form.section.optional" />
            </h3>
            <SelectField
                name={pinFields.category}
                options={categories}
                label={intl.formatMessage({ id: `pins.add.form.category.label` })}
                labelAlign="left"
                labelCol={{ span: 24 }}
            />
            <TextField
                name={pinFields.color}
                label={intl.formatMessage({ id: `pins.add.form.color.label` })}
                labelAlign="left"
                labelCol={{ span: 24 }}
            />
            <Button type="primary" htmlType="submit" loading={submitting}>
                <FormattedMessage id="pins.add.form.submit" />
            </Button>
            <Button type="danger" onClick={cancel}>
                <FormattedMessage id="pins.add.form.cancel" />
            </Button>
        </form>
    );
};

PinsForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    error: PropTypes.string,
};

PinsForm.defaultProps = {
    error: null,
};

export default PinsForm;
